import { Button, Form, Input, Modal, message } from "antd";
import { useState } from "react";
import ProfileService from "../service/profile-service";

const PushNotification = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSend = async (values) => {
    setLoading(true);
    try {
      await ProfileService.sendNotification(values);
      message.success("Push notification sent successfully");
      form.resetFields();
      onClose();
    } catch (err) {
      message.error(
        err?.response?.data?.errors?.[0]?.msg || "Failed to send notification"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Send Push Notification"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSend}
        autoComplete="off"
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Title is required" },
            { max: 100, message: "Title cannot exceed 100 characters" },
          ]}
        >
          <Input placeholder="Enter notification title" maxLength={100} />
        </Form.Item>
        <Form.Item
          label="Message"
          name="body"
          rules={[
            { required: true, message: "Message is required" },
            { max: 200, message: "Message cannot exceed 200 characters" },
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter notification message"
            maxLength={200}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Send Notification
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PushNotification;
